import React, { Component } from 'react'

export default class StatusMessages extends Component{

    render(){
        const { type, message } = this.props;
        const hasMessages = message !== undefined && message.length > 0;

        return(
            <div className="status-holder clearfix">
                {
                    type === "success" && hasMessages ? 
                        <div className="alert alert-success">
                            <i className="icon ion-checkmark-circled"></i> { message }
                        </div>
                    :
                        null
                }
                {
                    type === "error" && hasMessages ? 
                        <div className="alert alert-danger">
                            <i className="icon ion-close-circled"></i>
                            <ul>
                            {
                                message.map((msg, index)=>{                                     
                                    return(
                                        <li key={index}>{ msg }</li>
                                    )
                                })
                            }
                            </ul>
                        </div>
                    :
                        null
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/StatusMessages2.jsx